import downArrow from '../assets/icons/down_arrow.svg';
import back from '../assets/icons/back.svg';
import download from '../assets/icons/download.svg';
import cross from '../assets/icons/cross.svg';
import modalCross from '../assets/icons/modal_cross.svg';
import delete_icon from '../assets/icons/delete.svg';
import showPassword from '../assets/icons/show_password.svg';
import hidePassword from '../assets/icons/hide_password.svg';
import check from '../assets/icons/check_icon.svg';
import info from '../assets/icons/info.svg';
import success_check from '../assets/icons/success_check.svg';
import arabic_lang_icon from '../assets/icons/arabic_lang_icon.svg';
import error_icon from '../assets/icons/error_icon.svg';
import success_icon from '../assets/icons/success_icon.svg';
import info_icon from '../assets/icons/info_icon.svg';
import arabic_lang_white_icon from '../assets/icons/arabic_lang_white_icon.svg';
import individual_icon from '../assets/icons/individual_icon.svg';
import institutional_icon from '../assets/icons/institutional_icon.svg';
import application_icon from '../assets/icons/application_icon.svg';
import email_icon from '../assets/icons/email_icon.svg';
import logout_icon from '../assets/icons/logout_icon.svg';
import document_icon from '../assets/icons/document_icon.svg';
import nafath_logo_icon from '../assets/icons/nafath_logo_icon.svg';
import absher_logo_icon from '../assets/icons/absher_logo_icon.svg';
import general_information_icon from '../assets/icons/general_information_icon.svg';
import general_information_active_icon from '../assets/icons/general_information_active_icon.svg';
import contact_information_icon from '../assets/icons/contact_information_icon.svg';
import contact_information_active_icon from '../assets/icons/contact_information_active_icon.svg';
import account_operation_icon from '../assets/icons/account_operation_icon.svg';
import account_operation_active_icon from '../assets/icons/account_operation_active_icon.svg';
import client_classification_icon from '../assets/icons/client_classification_icon.svg';
import client_classification_active_icon from '../assets/icons/client_classification_active_icon.svg';
import investment_profile_icon from '../assets/icons/investment_profile_icon.svg';
import investment_profile_active_icon from '../assets/icons/investment_profile_active_icon.svg';
import bank_custodian_icon from '../assets/icons/bank_custodian_icon.svg';
import bank_custodian_active_icon from '../assets/icons/bank_custodian_active_icon.svg';
import digital_channel_icon from '../assets/icons/digital_channel_icon.svg';
import digital_channel_active_icon from '../assets/icons/digital_channel_active_icon.svg';
import document_upload_icon from '../assets/icons/document_upload_icon.svg';
import document_upload_active_icon from '../assets/icons/document_upload_active_icon.svg';
import review_submit_icon from '../assets/icons/review_submit_icon.svg';
import review_submit_active_icon from '../assets/icons/review_submit_active_icon.svg';
import info_blue from '../assets/icons/info_blue.svg';
import upload_icon from '../assets/icons/upload_icon.svg';
import plus_icon from '../assets/icons/plus_icon.svg';
import download_grey_icon from '../assets/icons/download_grey_icon.svg';
import edit_icon from '../assets/icons/edit_icon.svg';
import delete_outline_icon from '../assets/icons/delete_outline_icon.svg';
import general_information_filled_icon from '../assets/icons/general_information_filled_icon.svg';
import contact_information_filled_icon from '../assets/icons/contact_information_filled_icon.svg';
import account_operation_filled_icon from '../assets/icons/account_operation_filled_icon.svg';
import client_classification_filled_icon from '../assets/icons/client_classification_filled_icon.svg';
import investment_portfolio_filled_icon from '../assets/icons/investment_portfolio_filled_icon.svg';
import bank_custodian_filled_icon from '../assets/icons/bank_custodian_filled_icon.svg';
import digital_channel_filled_icon from '../assets/icons/digital_channel_filled_icon.svg';
import document_upload_filled_icon from '../assets/icons/document_upload_filled_icon.svg';
import info_red_icon from '../assets/icons/info_red_icon.svg';
import heading_info_outline_icon from '../assets/icons/heading_info_outline.svg';
import field_info_outline from '../assets/icons/field_info_outline.svg';
import application_info_red from '../assets/icons/application_info_red.svg';
import blue_tick_icon from '../assets/icons/blue_tick_icon.svg';
import infologout from '../assets/icons/info_logout.svg';

const icons = {
    downArrow,
    back,
    download,
    cross,
    modalCross,
    delete_icon,
    showPassword,
    hidePassword,
    check,
    info,
    success_check,
    arabic_lang_icon,
    error_icon,
    success_icon,
    info_icon,
    arabic_lang_white_icon,
    individual_icon,
    institutional_icon,
    application_icon,
    email_icon,
    logout_icon,
    document_icon,
    nafath_logo_icon,
    absher_logo_icon,
    general_information_icon,
    general_information_active_icon,
    contact_information_icon,
    contact_information_active_icon,
    account_operation_icon,
    account_operation_active_icon,
    client_classification_icon,
    client_classification_active_icon,
    investment_profile_icon,
    investment_profile_active_icon,
    bank_custodian_icon,
    bank_custodian_active_icon,
    digital_channel_icon,
    digital_channel_active_icon,
    document_upload_icon,
    document_upload_active_icon,
    review_submit_icon,
    review_submit_active_icon,
    info_blue,
    upload_icon,
    plus_icon,
    download_grey_icon,
    edit_icon,
    delete_outline_icon,
    general_information_filled_icon,
    contact_information_filled_icon,
    account_operation_filled_icon,
    client_classification_filled_icon,
    investment_portfolio_filled_icon,
    bank_custodian_filled_icon,
    digital_channel_filled_icon,
    document_upload_filled_icon,
    info_red_icon,
    heading_info_outline_icon,
    field_info_outline,
    application_info_red,
    blue_tick_icon,
    infologout,
};

export default icons;
